import { render, staticRenderFns } from "./RuleGame.vue?vue&type=template&id=95e0effa"
import script from "./RuleGame.vue?vue&type=script&lang=js"
export * from "./RuleGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports